const validateTabbedForm = (formElem) => {
    if (!formElem) return;

    // 0. Limpiar errores previos: quitamos 'text-danger' de los botones de las pestañas
    formElem.querySelectorAll("ul[role='tablist'] button.text-danger").forEach((tab) => tab.classList.remove("text-danger"));
    formElem.querySelectorAll(".is-invalid").forEach((tab) => tab.classList.remove("is-invalid"));

    // 1. Buscamos todos los elementos con el atributo 'required'
    const requiredElements = formElem.querySelectorAll("[required]");
    const formResult = {
        isValid: true,
        errors: [],
    };
    requiredElements.forEach((element) => {
        // 2. Comprobamos si están vacíos
        if (!element.value || element.value.trim() === "") {
            // añadimos is-invalid al input
            element.classList.add("is-invalid");
            // marcamos el resultado como falso
            formResult.isValid = false;
            // extraemos la etiqueta <label> del elemento
            const label = formElem.querySelector(`label[for="${element.id}"]`);
            // añadimos el texto del label al array de errores
            formResult.errors.push(label.textContent);
            // 3. Extraer el padre que es un tabpanel
            const tabPanel = element.closest('div[role="tabpanel"]');

            if (tabPanel) {
                // 4. Localizar el id del botón mediante aria-labelledby
                const tabButtonId = tabPanel.getAttribute("aria-labelledby");
                const tabButton = formElem.querySelector(`#${tabButtonId}`);

                if (tabButton) {
                    // 5. Cambiar la clase a text-danger de Bootstrap
                    tabButton.classList.add("text-danger");
                }
            }
        }
    });
    return formResult;
};

export default validateTabbedForm;
